var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "hero-page-container" },
        [_c("HeroSlider", { attrs: { data: _vm.slider, effect: "fade" } })],
        1
      ),
      _vm._v(" "),
      _vm._t("about"),
      _vm._v(" "),
      _c("KeyTopics", { attrs: { data: _vm.keyTopics } }),
      _vm._v(" "),
      _vm._t("recommended"),
      _vm._v(" "),
      _c("MainPageNews", { attrs: { data: _vm.pageNews } }),
      _vm._v(" "),
      _vm._t("sustainability"),
      _vm._v(" "),
      _vm._t("see-also")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d9db5086", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9db5086","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/components/main-page/main-page.vue
// module id = 115
// module chunks = 0